import { computed, action, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IResetPasswordConfiguration } from '../models';
import { utils } from '@kurtosys/ksys-app-template';

export class ResetPasswordStore extends StoreBase {
	static componentKey: 'resetPassword' = 'resetPassword';

	@computed
	get configuration(): IResetPasswordConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(ResetPasswordStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	public onSubmitPasswordResetRequest = async () => {
		const { messageStore, appStore, kurtosysApiStore } = this.storeContext;
		const { componentKey } = ResetPasswordStore;
		const { userName, clientName } = appStore;

		messageStore.clearAll(componentKey);

		if (utils.typeChecks.isNullOrEmpty(userName)) {
			messageStore.setErrorText(this.userNameNotFoundErrorMessage, ResetPasswordStore.componentKey);
			return false;
		}

		const loadingKey = 'ResetPasswordStore.onSubmitPasswordResetRequest';
		appStore.startLoading(loadingKey);

		const overrides = {
			body: {
				userName,
				clientName,
			},
		};
		const response = await kurtosysApiStore.passwordReset.callApi(overrides);
		if (response.status === 200) {
			messageStore.setInfoText(this.successMessage, componentKey);

		}
		else {
			messageStore.setErrorText(this.errorMessage, componentKey);
		}
		appStore.stopLoading(loadingKey);
	}

	@computed
	get resetPasswordButtonText(): string {
		return (this.configuration && this.configuration.resetPasswordButtonText) || 'Reset Password';
	}

	@computed
	get successMessage(): string {
		return (this.configuration && this.configuration.successMessage) ||
			'If your user exists, you should receive an email with more information, please follow the instructions listed there';
	}

	@computed
	get errorMessage(): string {
		return (this.configuration && this.configuration.errorMessage) ||
			'An error occurred while processing this request. Please contact your administrator';
	}

	@computed
	get userNameNotFoundErrorMessage(): string {
		return (this.configuration && this.configuration.userNameNotFoundErrorMessage) ||
			'The user name could not be found';
	}
}